var React = require('react');

function MobIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 13.963V2.03704C1 1.41481 1.38095 1 1.95238 1H8.04762C8.61905 1 9 1.41481 9 2.03704V13.963C9 14.5852 8.61905 15 8.04762 15H1.95238C1.38095 15 1 14.5852 1 13.963Z","stroke":"white","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M1 11.2666H9","stroke":"white","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M4.33325 13.0298H5.76182","stroke":"white","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M4.90479 2.76318H5.1905","stroke":"white","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

MobIcon.defaultProps = {"width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"};

module.exports = MobIcon;

MobIcon.default = MobIcon;
